
document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-leads')

    if (section) {
        const cards = section.querySelectorAll('.section-leads__card:nth-child(n+5)');
            const toggleBtn = section.querySelector('.section-leads__btn');
            let isExpanded = false;

            cards.forEach((card) => {
                gsap.set(card, {
                    display: "none",
                    height: 0
                });
            });

            toggleBtn.addEventListener('click', () => {
                if (isExpanded) {
                    cards.forEach((card, index) => {
                        slideUp(card);
                    });
                    toggleBtn.querySelector('.button__text-box').textContent = 'Показать больше';
                } else {
                    cards.forEach((card, index) => {
                        slideDown(card);
                    });
                    toggleBtn.querySelector('.button__text-box').textContent = 'Свернуть';
                }
                isExpanded = !isExpanded;
            });

        // Функции анимации
        function slideUp(element, duration = 0.3) {
            gsap.to(element, {
                height: 0,
                duration: duration,
                ease: "power2.inOut",
                onComplete: () => {
                    gsap.set(element, { display: "none" });
                    ScrollTrigger.refresh();

                    toggleBtn.scrollIntoView(false)
                }
            });
        }

        function slideDown(element, duration = 0.3) {
            gsap.set(element, {
                display: "block",
                height: "auto"
            });

            const height = element.offsetHeight;
            gsap.set(element, { height: 0 });

            gsap.to(element, {
                height: height,
                duration: duration,
                ease: "power2.inOut",
                onComplete: () => {
                    ScrollTrigger.refresh();
                }
            });
        }
    }
})